import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { Loader2, Search, Users } from "lucide-react";
import api from "@/lib/api";
import Member360 from "@/components/crm/Member360";

export const ManagerMembersPanel = () => {
  const [q, setQ] = useState("");
  const [selected, setSelected] = useState(null);
  const { data: clients = [], isLoading } = useQuery({
    queryKey: ["mgr-members", q],
    queryFn: () => api.get("/pos/clients", { params: { q } }).then((r) => r.data),
  });

  if (selected) return <Member360 userId={selected} onBack={() => setSelected(null)} />;

  return (
    <div data-testid="mgr-members-panel">
      <div className="flex flex-wrap items-center justify-between gap-3 mb-5">
        <div>
          <h2 className="font-serif text-2xl text-[#1A242B]">Members</h2>
          <p className="text-sm text-[#4A5D6B]">Your center's members — open a full profile to see sessions, packages, events, notes, and intake forms.</p>
        </div>
        <div className="relative">
          <Search size={15} className="absolute left-3 top-1/2 -translate-y-1/2 text-[#8FA89B]" />
          <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search by name or email…" data-testid="mgr-members-search" className="eyw-input !pl-9 w-64" />
        </div>
      </div>
      {isLoading ? <p className="text-sm text-[#4A5D6B] flex items-center gap-2"><Loader2 className="animate-spin" size={16} /> Loading…</p> : (
        <div className="eyw-card overflow-hidden">
          <table className="w-full text-sm">
            <thead className="bg-[#F4F1EB] text-[#4A5D6B]">
              <tr><th className="text-left px-4 py-3">Name</th><th className="text-left px-4 py-3 hidden md:table-cell">Email</th><th className="text-left px-4 py-3 hidden sm:table-cell">Phone</th><th /></tr>
            </thead>
            <tbody className="divide-y divide-[#E5E0D8]">
              {clients.map((c) => (
                <tr key={c.id} className="hover:bg-[#F9F7F3]" data-testid={`mgr-member-row-${c.id}`}>
                  <td className="px-4 py-3 text-[#1A242B]">{[c.first_name, c.last_name].filter(Boolean).join(" ") || c.email || "—"}</td>
                  <td className="px-4 py-3 text-[#4A5D6B] hidden md:table-cell">{c.email || "—"}</td>
                  <td className="px-4 py-3 text-[#8FA89B] hidden sm:table-cell">{c.phone || "—"}</td>
                  <td className="px-4 py-3 text-right">
                    {c.user_id ? (
                      <button onClick={() => setSelected(c.user_id)} data-testid={`mgr-member-open-${c.id}`} className="text-xs text-[#144F75] font-medium hover:underline">Full profile</button>
                    ) : <span className="text-[11px] text-[#8FA89B]">no account</span>}
                  </td>
                </tr>
              ))}
              {clients.length === 0 && <tr><td colSpan={4} className="px-4 py-10 text-center text-[#8FA89B]"><Users size={22} className="mx-auto mb-2 opacity-60" /> No members found.</td></tr>}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default ManagerMembersPanel;
